// String values match the backend ContactPermission enum on the wire.
export enum ContactPermission {
  ALL = 'ALL',
  P = 'P',
  M = 'M',
  N = 'N'
}
